import type { Supplier, SupplierMitigationTask } from '../../types'
import {
  extractSupplierListFilters,
  supplierMatchesGeoFilter,
} from './earlySignalsDbIntent'

/**
 * Match region/location filter against plant location, supplier location, and kenvue_region.
 * Display location alone is often a country (France) while users filter by region (EMEA).
 */
export function mitigationMatchesRegionOrLocation(
  task: Pick<SupplierMitigationTask, 'plant_location'>,
  supplier: Pick<Supplier, 'location' | 'kenvue_region'> | null | undefined,
  regionText: string
): boolean {
  const q = regionText.trim().toLowerCase()
  if (!q) return true

  const plant = (task.plant_location || '').trim()
  const loc = (supplier?.location || '').trim()
  const region = (supplier?.kenvue_region || '').trim()
  const haystacks = [plant, loc, region].map((s) => s.toLowerCase()).filter(Boolean)

  if (haystacks.some((h) => h.includes(q))) return true

  // Canonical geo parse (EMEA / NA / USA / Germany / …)
  const filters = extractSupplierListFilters(regionText)
  const hasGeo =
    Boolean(filters.geoKind) ||
    Boolean(filters.regionHint) ||
    Boolean(filters.locationHints && filters.locationHints.length > 0)
  if (!hasGeo) return false

  if (supplier && supplierMatchesGeoFilter(supplier, filters)) return true

  // plant_location often holds the country even when supplier.location differs
  if (plant) {
    if (
      supplierMatchesGeoFilter(
        { location: plant, kenvue_region: supplier?.kenvue_region ?? null },
        filters
      )
    ) {
      return true
    }
  }

  return false
}
